import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DownloadExcelComponent } from 'src/app/module/shared/components/download-excel/download-excel.component';
import { ViewEditCommonComponent } from 'src/app/module/shared/components/view-edit-common/view-edit-common.component';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { TabService } from 'src/app/shared/tab.service';
import { AddordersComponent } from '../add-orders/add-orders.component';
import { CommonBulkPrintComponent } from 'src/app/module/shared/components/common-bulk-print/common-bulk-print.component';
import { CommonCsvComponent } from 'src/app/module/shared/components/common-csv/common-csv.component';
import { debounceTime, Observable, Subject } from 'rxjs';
import { ordersService } from '../../services/orders.service';
import { NeAddOrderComponent } from '../ne-add-order/ne-add-order.component';
import { CreateTmsOrderComponent } from '../tms-order/create-tms-order/create-tms-order.component';
import { ViewBiddingComponent } from '../view-bidding/view-bidding.component';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class ordersComponent {
  theme = 'dark'
  pageSize = 50; // Number of items per page
  pageIndex = 0;
  currentPage: number = 0;
  pageNumber = 0;
  sortingCol: string = 'id';
  direction: string = 'DESC'
  tableName = 'orderTable'
  warehouseFilter: any = [];
  warehouseData: any = [];
  getWarehouseList: any;
  customerModel: any;
  selectedWarehouse: any;
  storedWarehouse: any;
  clientId: any;
  clientDetails: any;
  ref: DynamicDialogRef | undefined;
  selectedData: any[] = [];
  editContation: boolean = false;
  first: number = 0;
  // filters= [];
  filters: { key: string; value: any }[] = [];
  userType: any;
  
  // ── Submit Rate dialog state ──
  showSubmitRateDialog = false;
  submitRateStep: 'confirm' | 'form' = 'confirm';
  inviteVendors = false;
  currentOrderForRate: any = null;
  rateForm!: FormGroup;
 
  vendorList: any[] = [];
 
  showBiddingDialog = false;
  currentBiddingOrder: any = null;
  biddingForm!: FormGroup;
  biddingLoading = false;
  selectedBiddingItem: any = null;
  showBiddingConfirmDialog = false;
  pendingBiddingStatus: string | null = null;

  columns = [
    // { showColumn: false, sortingColumn: '', key: 'orderNumber', header: 'Order Id', sortable: false, type: 'text', viewDialog: true, viewHistory: true, componentName: 'orders' },
    // {showColumn: true, sortingColumn: '',  key: 'orderCode', header: ' Order Code ', sortable: false, type: 'text', viewDialog: false },
    { showColumn: true, sortingColumn: '', key: 'orderNumber', header: 'Order No', sortable: false, viewDialog: true, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'warehouseCode', header: 'Warehouse', sortable: false, type: 'text', viewDialog: false },
    // { showColumn: true, sortingColumn: '', key: 'customerWarehouseId', header: 'Warehouse', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: '',  key: 'vendors', header: 'Vendor', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: '',  key: 'headCountNeeded', header: 'Head Count', sortable: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'status', header: 'LR Number', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'customerName', header: 'Customer', sortable: false, type: 'text', viewDialog: false },
    // { showColumn: true, sortingColumn: '', key: 'fromDate', header: 'Date of Placement', sortable: false, type: 'invoicedate' },
    // { showColumn: true, sortingColumn: '', key: 'jobLineItems', header: 'Route Details', sortable: false, type: 'RouteDetails' },
    { showColumn: true, sortingColumn: '', key: 'route', header: 'Route', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'orderType', header: 'Type', sortable: false, viewDialog: false, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'contactAlternateMobile', header: 'Contact Alternate Number', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'contactEmail', header: 'KAM', sortable: false, viewDialog: false, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'fromDate', header: 'Order From Date', sortable: false, type: 'invoicedate' },
    { showColumn: true, sortingColumn: '', key: 'remarks', header: 'Price Status', sortable: false, viewDialog: false, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'districtName', header: 'Location', sortable: false, viewDialog: false, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'stateName', header: 'State', sortable: false, viewDialog: false, type: 'text' },
    // {showColumn: true, sortingColumn: 'createdAt',  key: 'createdAt', header: 'Created At', sortable: true, type: 'date' },
    // {showColumn: true, sortingColumn: '',  key: 'createdByName', header: 'Created By', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: 'updatedAt',  key: 'updatedAt', header: 'Updated At', sortable: true, type: 'date' },
    // {showColumn: true, sortingColumn: '',  key: 'updatedByName', header: 'Updated By', sortable: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: '', header: 'Action', sortable: false, type: 'action', viewDialog: true, viewHistory: true, componentName: 'orders' },

  ];

  columnsToExport: string[] = ['financialYearId', 'budgetDate', 'budgetType', 'reference', 'accountName', 'warehouseName', 'approvedBudget', 'expense', 'createdAt', 'createdByName', 'updatedAt', 'updatedByName', 'budgetProof', 'remarks'];

  dropdownOptions: { [key: number]: string[] } = {
    0: ['2023-2024', '2022-2023'],
    1: ['January', 'February', 'March'],
  };

  warehouseList = []; // Define warehouse list here
  accounts = []; // Define account list here
  totalCount: any;
  @ViewChild(DownloadExcelComponent) downloadExcel!: DownloadExcelComponent;
  @ViewChild(CommonBulkPrintComponent) printData!: CommonBulkPrintComponent;
  @ViewChild(CommonCsvComponent) downloadCsv!: CommonCsvComponent;

  selectedRows: any[] = [];
  tableLists: any = [];
  user_details: any;
  activeQuickFilter: string | null = null;
  private getListTrigger$ = new Subject<void>();
  roleName:any;
  quickFilters: any[] = []; // populated per-role in ngOnInit via setupQuickFilters()

  private quickFilterConfig: { [role: string]: any[] } = {
  
    ROLE_KAM: [
      { label: 'Others',          value: 'OTHERS',           color: '#9ca3af', count: 0,
        filters: [{ key: 'STATUS', value: 'ORDER_CONFIRMED' }] },
      { label: 'Pending Action',  value: 'PENDING_ACTION',   color: '#7c3aed', count: 0,
        filters: [{ key: 'STATUS', value: 'QUOTE_SHARED,HEAD_APPROVED' }] },
      { label: 'Pending on Prod', value: 'PENDING_ON_PROD',  color: '#f59e0b', count: 0,
        filters: [{ key: 'STATUS', value: 'CREATED,QUOTE_PENDING' }] },
      { label: 'Pending on Head', value: 'PENDING_ON_HEAD',  color: '#f59e0b', count: 0,
        filters: [{ key: 'STATUS', value: 'HEAD_PENDING' }] },
    ],
  
    ROLE_PROCUREMENT: [
      { label: 'Quote Requested',     value: 'QUOTE_REQUESTED',     color: '#7c3aed', count: 0,
        filters: [{ key: 'BIDDING_ENABLE', value: '0' }, { key: 'STATUS', value: 'CREATED,QUOTE_PENDING' }] },
      { label: 'Pending on KAM',      value: 'PENDING_ON_KAM',      color: '#f59e0b', count: 0,
        filters: [{ key: 'STATUS', value: 'QUOTE_SHARED,HEAD_APPROVED' }] },
      { label: 'Pending on Head',     value: 'PENDING_ON_HEAD',     color: '#f59e0b', count: 0,
        filters: [{ key: 'STATUS', value: 'HEAD_PENDING' }] },
      { label: 'Pending Trips',       value: 'PENDING_TRIPS',       color: '#ef4444', count: 0,
        filters: [{ key: 'STATUS', value: 'ORDER_CONFIRMED' }] },
      { label: 'Bidding in Progress', value: 'BIDDING_IN_PROGRESS', color: '#3b82f6', count: 0,
        filters: [{ key: 'BIDDING_ENABLE', value: '1' }, { key: 'STATUS', value: 'CREATED,QUOTE_PENDING' }] },
      { label: 'Others',              value: 'OTHERS',              color: '#9ca3af', count: 0,
        filters: [{ key: 'TRIP_STATUS', value: 'TRIP_ENDED' }] },
    ],
  
    ROLE_OPERATION: [
      { label: 'Trip in Progress', value: 'TRIP_IN_PROGRESS', color: '#7c3aed', count: 0,
        filters: [{ key: 'STATUS', value: 'ORDER_CONFIRMED' }, { key: 'TRIP_STATUS', value: 'TRIP_INPROGRESS,TRIP_GENERATED' }] },
      { label: 'Others',           value: 'OTHERS',           color: '#9ca3af', count: 0,
        filters: [] },
    ],
  
    ROLE_HEAD: [
      { label: 'Pending on Head', value: 'PENDING_ON_HEAD', color: '#f59e0b', count: 0,
        filters: [{ key: 'STATUS', value: 'HEAD_PENDING' }] },
    ],
  };
  constructor(private ordersService: ordersService,
    private primengConfig: PrimeNGConfig, private fb: FormBuilder, private tabService: TabService,
    public dialogService: DialogService, private messageService: MessageService, private router: Router, public accessControlService: AccessControlService) {
    
      this.getListTrigger$.pipe(debounceTime(0)).subscribe(() => this.fetchList());
      
      this.getWarehouseList = JSON.parse(localStorage.getItem('wareHouseList')!)
    this.accounts = JSON.parse(localStorage.getItem('accountList')!)
    this.user_details = JSON.parse(localStorage.getItem('UserDetails')!);
    this.roleName = this.user_details.roleName;

    this.userType = this.user_details?.userType;
    this.primengConfig.ripple = true;
  }

  searchForm = this.fb.group({
    WAREHOUSE_ID_IN: new FormControl(''),
    ACCOUNT_ID_IN: new FormControl(''),
    // FC_NAME: new FormControl(''),
    STATUS: new FormControl(null)
  });

  ngOnInit(): void {
    this.buildRateForm();
    this.buildBiddingForm();
    // this.getList()
    this.setupQuickFilters();
  }

  setupQuickFilters(): void {
    this.quickFilters = this.quickFilterConfig[this.roleName] || [];
  
    if (this.roleName === 'ROLE_VENDOR' || this.quickFilters.length === 0) {
      this.getList();
      return;
    }
  
    // Default: select the first quick filter automatically
    this.onQuickFilter(this.quickFilters[0]);
  }
  
  /** Every key any quick filter for the current role can set — used to clear
   *  the previous chip's keys before applying a new one, since chips can set
   *  different keys (STATUS vs BIDDING_ENABLE vs TRIP_STATUS). */
  private get quickFilterKeys(): string[] {
    const keys = new Set<string>();
    this.quickFilters.forEach(qf => (qf.filters || []).forEach((f: any) => keys.add(f.key)));
    return Array.from(keys);
  }
  
  // ─────────────────────────────────────────────
  // Submit Rate — inline dialog logic
  // ─────────────────────────────────────────────
 
  isAllSelected(): boolean {
    const selected = this.rateForm.get('vendors')?.value || [];
    return selected.length === this.vendorList.length;
  }
  
  isSomeSelected(): boolean {
    const selected = this.rateForm.get('vendors')?.value || [];
    return selected.length > 0 && selected.length < this.vendorList.length;
  }
  
  toggleSelectAll(): void {
    const allIds = this.vendorList.map(v => v.id);
    const selected = this.rateForm.get('vendors')?.value || [];
  
    if (selected.length === this.vendorList.length) {
      // all selected → deselect all
      this.rateForm.get('vendors')?.setValue([]);
    } else {
      // none or some selected → select all
      this.rateForm.get('vendors')?.setValue(allIds);
    }
  }

  getVendorList(){
    this.ordersService.getVendorInfo([],0,100000).subscribe((res:any)=>{
      this.vendorList = res?.responseObject?.content
    })
  }

  buildRateForm(): void {
    this.rateForm = this.fb.group({
      rate:    [null, [Validators.required, Validators.min(1)]],
      vendors: [null, Validators.required]
    });
  }
 
  openSubmitRate(item: any): void {
    this.getVendorList()
    this.currentOrderForRate = item;
    this.submitRateStep = 'confirm';
    this.inviteVendors = false;
    this.rateForm.reset();
    this.rateForm.controls['rate'].setValue(item?.profitAdjustedCustomerAmount.toString())
    this.showSubmitRateDialog = true;
  }
 
  onYesInvite(): void {
    this.inviteVendors = true;
    this.submitRateStep = 'form';
  }
 
  onNoJustSubmit(): void {
    this.inviteVendors = false;
    this.submitRateStep = 'form';
  }
 
  onRateBack(): void {
    this.submitRateStep = 'confirm';
    this.rateForm.reset();
  }
 
  isRateInvalid(field: string): boolean {
    const ctrl = this.rateForm.get(field);
    return !!ctrl && ctrl.touched && ctrl.invalid;
  }
 
  onSubmitRate(): void {
  if (this.rateForm.invalid) {
    this.rateForm.markAllAsTouched();
    return;
  }

  const formValue = this.rateForm.value;

  let payload: any;

  if (this.inviteVendors) {
    payload = {
      id:                       this.currentOrderForRate?.id,
      procurementProvidedAmount: formValue.rate,
      biddingEnable:            1,
      biddingStatus:            'PendingOnVendor',
      vendorIds:                formValue.vendors
    };
  } else {
    payload = {
      id:                       this.currentOrderForRate?.id,
      procurementProvidedAmount: formValue.rate,
      status:                   'QUOTE_SHARED',
      vendorId:                 formValue.vendors
    };
  }

  console.log('Submit Rate Payload:', payload);

  this.ordersService.createUpdateOrder(payload).subscribe({
    next: (res: any) => {
      this.showSubmitRateDialog = false;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res?.responseMessage || 'Rate submitted successfully'
      });
      this.getList();
    },
    error: (err: any) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err?.error?.responseMessage || 'Something went wrong'
      });
    }
  });
}
 
  closeSubmitRateDialog(): void {
    this.showSubmitRateDialog = false;
  }

  getWarehouseDetails(pageIndex: number, pageSize: number, filter: any) {
    // const warehouseFilter = this.setFilter();
    this.warehouseData = []
    this.totalCount = 0
    // this.warehouseService.getWarehouseList(pageIndex, pageSize, filter).subscribe((res: any) => {
    //   this.warehouseData = res?.responseObject?.content;
    //   this.totalCount = res?.responseObject?.totalElements;
    // })
  }

  
  reloadEvent(event:any){
    console.log(event);
    this.getList()
  }

  getList(): void {
    this.getListTrigger$.next();
  }
  
  private fetchList() {
    let postData: any[] = [];
    let vendorIds: string[] = [];
    let accountIds: any;
  
    if (this.user_details?.vendorMapping?.length > 0) {
      vendorIds = this.user_details.vendorMapping.map((el: any) => el.vendorId || el.id);
    }
    if (this.user_details?.accountMapping?.length > 0) {
      accountIds = this.user_details.accountMapping.map((el: any) => el.accountId || el.id);
    }
  
    // ROLE_VENDOR — use bidding service with VENDOR_ID_IN filter
    if (this.roleName === 'ROLE_VENDOR') {
      const vendorFilter = [
        { key: 'VENDOR_ID_IN', value: vendorIds.join(',') }
      ];
  
      this.tableLists = [];
      this.ordersService
        .getVendorOrders(vendorFilter, this.pageNumber, this.pageSize, this.sortingCol, this.direction)
        .subscribe((data: any) => {
          if (data) {
            this.tableLists = data?.responseObject?.content || [];
            this.tableLists.forEach((el: any) => {
              if (el?.source && el?.destination) {
                el.route = el?.source + ' - ' + el?.destination;
              }
            });
            this.totalCount = data?.responseObject?.totalElements;
            this.tableLists = this.tableLists.filter((el: any) => el.status !== 'Draft');
            this.selectedData = [];
          }
        }, err => {
          this.totalCount = 0;
          this.tableLists = [];
        });
  
      return;
    }
  
    // ── Rebuild filters fresh every time: strip whatever quick-filter keys
    //    might already be sitting in this.filters, then reapply the CURRENTLY
    //    active chip's key/values. This means no matter who called getList()
    //    (init, search, reset, chip click), the active quick filter can never
    //    silently disappear. ──
    this.filters = this.buildFilters();
  
    this.tableLists = []
    this.ordersService
      .getFtlOrders(this.filters, this.pageNumber, this.pageSize, this.sortingCol, this.direction)
      .subscribe((data: any) => {
        if (data) {
          this.tableLists = data?.responseObject?.content;
          this.tableLists.forEach((el: any) => {
            if (el?.source && el?.destination) {
              el.route = el?.source + ' - ' + el?.destination;
            }
          });
          this.totalCount = data?.responseObject?.totalElements;
          this.tableLists = this.tableLists.filter((el: any) => el.status !== 'Draft');
          this.selectedData = []
        }
      }, err => {
        this.totalCount = 0
        this.tableLists = []
      });
  }

  private buildFilters(): { key: string; value: any }[] {
    // Start from whatever base/search filters currently exist, minus any
    // quick-filter keys (so we don't double up or carry stale ones)
    let base = (this.filters || []).filter((f: any) => !this.quickFilterKeys.includes(f.key));
  
    // Reapply the active quick filter's key/values fresh from config
    if (this.activeQuickFilter) {
      const active = this.quickFilters.find(qf => qf.value === this.activeQuickFilter);
      if (active) {
        base = [...base, ...(active.filters || [])];
      }
    }
  
    return base.filter(
      (item: any) =>
        (item.value && item.value.toString().trim() !== '') ||
        (item.dateValue && item.dateValue.toString().trim() !== '')
    );
  }

  getListExportApi = (params: any): Observable<any> => {
    const {
      filters = {}, pageNumber = 0, pageSize = 250, sortingCol = 'id',
      direction = 'DESC'
    } = params;

    return this.ordersService.getOrders(
      filters, pageNumber, pageSize, sortingCol, direction
    );
  };

  onFilterChange(event: any) {
    if (event) {
      console.log(event)
      this.filters = event
      this.getList()
    }
  }

  onResetFilters() {
    this.filters = []
    this.getList()
  }

  paginate(event: any) {
    this.pageNumber = event.pageIndex
    this.pageSize = event.pageSize
    this.currentPage = event.pageIndex
    this.first = event.pageIndex * event.pageSize
    this.getList()
  }

  onSortChange(event: { columnKey: string, sortOrder: 'ASC' | 'DESC' }): void {
    this.sortingCol = event.columnKey
    this.direction = event.sortOrder
    this.getList()
  }

  sortColumn(columnKey: string, sortOrder: 'ASC' | 'DESC') {
    this.onSortChange({ columnKey, sortOrder });
  }

  editOrderRow(item: any) {
    this.selectedData = [item];
    this.editEvent();
  }

  viewOrderDetails(id: any) {
    // open your view dialog / navigate to order detail
  }

  onSelectedRowsChange(selectedRows: any[]) {
    const storedData = JSON.parse(localStorage.getItem('columnToExport') || '{}');

    this.columnsToExport = storedData['budget'] ?? this.columnsToExport;

    this.selectedRows = selectedRows;
    this.selectedData = selectedRows;

    if (this.downloadExcel) {
      this.downloadExcel.data = [...selectedRows];
    } else {
      console.error('DownloadExcelComponent is not initialized.');
    }
  }

  addBudget(type: any) {
    // this.ref = this.dialogService.open(AddordersComponent, {
    this.ref = this.dialogService.open(NeAddOrderComponent, {
      header: `${type} Order`,
      data: type == 'Add' ? {} : {
        editData: this.selectedData,
        edit: this.editContation
      },
      width: '70vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getList()
    });
  }

  viewOrderHistory(id: any) {
    this.tabService.addTab({
      label: 'Order View',
      path: 'orders/order-view/' + id,
      fullPath: '',
      filterData: [],
    });
    this.router.navigate(['orders/order-view/' + id]);
  }

  createFtlOrder(type: any) {
    // this.ref = this.dialogService.open(AddordersComponent, {
    this.ref = this.dialogService.open( CreateTmsOrderComponent, {
      header: `${type} Order`,
      data: type == 'Add' ? {} : {
        editData: this.selectedData,
        edit: this.editContation
      },
      width: '70vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getList()
    });
  }

  receiveDataEvent(data: any[]) {
    console.log(data)
    this.selectedData = data
  }
  editEvent() {
    this.editContation = true
    console.log(this.editContation)
    this.createFtlOrder('Edit')
  }
  deleteEvent() {
    // const ids = Array.from(new Set(this.selectedData.map((item: any) => item.id))).join(',');
    // this.emsServices.deleteExpense(ids).subscribe((data: any) => {
    //   if(data){
    //     this.selectedData = [];
    //     this.getList();
    //     this.messageService.add({
    //       severity: 'success',
    //       summary: 'Success',
    //       detail: 'Expense Deleted successfully',
    //     });
    //   }
    //  },err => {
    //   this.tableLists = []
    //  });
  }

  duplicateEvent() {
    console.log(this.selectedData)
    const payload = {
      expenseCategoryId: this.selectedData[0].expenseCategoryId,
      expenseModeId: this.selectedData[0].expenseModeId,
      expenseName: this.selectedData[0].expenseName,
      status: this.selectedData[0].status,
    };
    //  this.emsServices.expenseAddOrUpdate(payload).subscribe((data: any) => {
    //   if(data){
    //    this.messageService.add({
    //      severity: 'success',
    //      summary: 'Success',
    //      detail: 'Expense added successfully',
    //    });
    //    this.getList();
    //    this.selectedData = [];
    //   }
    //  });
  }


  upload(url: any, params: any) {
    this.tabService.addTab({
      label: 'Upload', path: url,
      fullPath: '',
      filterData: [],
      // pageNumber: 0,
      // pageSize: 10
    });
    this.router.navigate([url], { queryParams: params })
  }

  onQuickFilter(filter: any): void {
    this.activeQuickFilter = this.activeQuickFilter === filter.value ? null : filter.value;
    this.pageNumber = 0;
    this.getList();
  }

  
buildBiddingForm(): void {
  this.biddingForm = this.fb.group({
    bidAmount:       [null, [Validators.required, Validators.min(1)]],
    vehicleProvided: [1,    [Validators.required, Validators.min(1)]]
  });
}
 
openBiddingDialog(item: any): void {
  this.currentBiddingOrder = item;
  this.biddingForm.reset({
    bidAmount:       item?.bidAmount       || null,
    vehicleProvided: item?.numberOfVehicle || 1
  });
  this.showBiddingDialog = true;
}
 
closeBiddingDialog(): void {
  this.showBiddingDialog = false;
  this.biddingLoading = false;
}
 
isBiddingInvalid(field: string): boolean {
  const ctrl = this.biddingForm.get(field);
  return !!ctrl && ctrl.touched && ctrl.invalid;
}
 
onBiddingAction(status: any, selectedBiddingItem: any): void {
 
  // Reject doesn't need form validation
  if (status !== 'RejectedByVendor' && this.biddingForm.invalid) {
    this.biddingForm.markAllAsTouched();
    return;
  }
 
  const formValue = this.biddingForm.value;
 
  const payload: any = {
    id:               selectedBiddingItem?.id,
    status:           status,
    finalAcceptance:  'VENDOR'
  };
 
  // Only include bid fields for Bidding and Accept actions
  if (status !== 'RejectedByVendor') {
    payload.bidAmount       = formValue.bidAmount;
    payload.vehicleProvided = formValue.vehicleProvided;
  }
 
  console.log('Bidding Payload:', payload);
 
  this.biddingLoading = true;
 
  this.ordersService.createUpdateOrderBidding(payload).subscribe({
    next: (res: any) => {
      this.biddingLoading = false;
      this.showBiddingDialog = false;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res?.responseMessage || 'Action completed successfully'
      });
      this.getList();
    },
    error: (err: any) => {
      this.biddingLoading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err?.error?.responseMessage || 'Something went wrong'
      });
    }
  });
}

openBiddingConfirmation(status: string, item?: any): void {
  this.pendingBiddingStatus = status;
  this.selectedBiddingItem = item || this.currentBiddingOrder;
  this.showBiddingConfirmDialog = true;
}

confirmBiddingAction(): void {
  if (!this.pendingBiddingStatus) {
    return;
  }

  this.showBiddingConfirmDialog = false;
  if(this.pendingBiddingStatus === 'AcceptedByVendor' || this.pendingBiddingStatus === 'RejectedByVendor'){
    this.biddingForm.controls['bidAmount'].setValue(this.selectedBiddingItem?.procurementPrice)
    this.biddingForm.controls['vehicleProvided'].setValue(this.selectedBiddingItem?.numberOfVehicles)
  }
  this.onBiddingAction(
    this.pendingBiddingStatus,
    this.selectedBiddingItem
  );

  this.pendingBiddingStatus = null;
  this.selectedBiddingItem = null;
}

cancelBiddingAction(): void {
  this.showBiddingConfirmDialog = false;
  this.pendingBiddingStatus = null;
}

openViewBidding(item: any): void {
  this.dialogService.open(ViewBiddingComponent, {
    header: `View Bidding — ${item.orderNumber}`,
    data: {
      order: item
    },
    width: '75vw',
    contentStyle: { overflow: 'auto' },
    draggable: false,
    styleClass: 'no-close-icon-dialog'
  });
}

checkTripStatus(item: any,status:any): boolean {
  return item?.orderStatus?.some(
    (el: any) =>
      el.statusType === 'TRIP_STATUS' &&
      el.status === status
  ) || false;
}
checkHardPod(item: any,status:any): boolean {
  return item?.orderStatus?.some(
    (el: any) =>
      el.statusType === 'HARD_POD_STATUS' &&
      el.status === status
  ) || false;
}
checkSoftPod(item: any, status: any): boolean {
  return item?.orderStatus?.some(
    (el: any) =>
      el.statusType === 'SOFT_POD_STATUS' &&
      el.status === status
  ) || false;
}

endTrip(item:any){
  this.tabService.addTab({
    label: 'End Trip',
    path: 'orders/end-trip/' + item?.id,
    fullPath: '',
    filterData: [],
  });
  this.router.navigate(['orders/end-trip/' + item?.id]);
}
startTrip(item: any) {
  const isPending = this.checkTripStatus(item, 'PENDING');

  if (isPending) {
    const payload = {
      orderId: item?.id,
      accountId: item?.accountId,
      customerId: item?.customerId,
      status: 'TRIP_GENERATED',
      vendorId: item?.vendorId,
    };

    this.ordersService.tripGenration(payload)
      .subscribe({
        next: () => this.goToTripPage(item),
        error: (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.responseMessage || 'Failed to create trip'
          });
        }
      });
  } else {
    this.goToTripPage(item);
  }
}

private goToTripPage(item: any) {
  this.tabService.addTab({
    label: 'Order Trip',
    path: 'orders/order-trip/' + item?.id,
    fullPath: '',
    filterData: [],
  });
  this.router.navigate(['orders/order-trip/' + item?.id]);
}

formatStatus(value: string): string {
  if (!value) return '';

  return value
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, c => c.toUpperCase());
}

getStatusClass(status: string): string {

  const value = (status || '').toUpperCase();

  if (
    value.includes('APPROVED') ||
    value.includes('RECEIVED') ||
    value.includes('COMPLETED') ||
    value.includes('PAID') ||
    value.includes('ENDED')
  ) {
    return 'status-success';
  }

  if (
    value.includes('PENDING') ||
    value.includes('GENERATED') ||
    value.includes('CREATED') ||
    value.includes('IN_PROGRESS') ||
    value.includes('STARTED')
  ) {
    return 'status-warning';
  }

  if (
    value.includes('REJECTED') ||
    value.includes('FAILED') ||
    value.includes('CANCELLED')
  ) {
    return 'status-danger';
  }

  return 'status-default';
}

getOrderStatusClass(status: string): string {

  const value = (status || '').toUpperCase();

  switch (value) {

    case 'QUOTE_PENDING_ON_KAM':
    case 'QUOTE_PENDING_ON_PROCUREMENT':
    case 'ORDER_PENDING':
    case 'QUOTE_PENDING':
      return 'order-warning';

    case 'ORDER_CONFIRMED':
      return 'order-success';

    case 'ORDER_CANCELLED':
    case 'ORDER_REJECTED':
      return 'order-danger';

    case 'ORDER_COMPLETED':
    case 'CREATED':
      return 'order-primary';

    default:
      return 'order-default';
  }
}

}
